<template lang="pug">
div
  .d-flex.justify-space-between.align-center.mb-2.mr-xl-10
    .text-sm.neutral500--text Stock {{ isReceivedMode ? 'received' : 'requested' }}
  .text-2xl.font-semibold.mb-2(:class="[countColor]") {{ stockCount }}
    span.font-normal(v-if="showProgressTotal") / {{ totalRequested }}
  v-progress-linear.rounded-lg(v-if="showProgressTotal" height="12" :value="requestPercentage" color="success")
  .text-sm.mb-8.danger500--text(v-if="!['quotation', 'stock-transfer'].includes(selectedDocument.id) && status === 'draft'") Finalize your draft to see total stock received.
  //- v-btn.button-sm.mb-8.to-bottom(outlined @click="$emit('updatedRequestStock')") Update requested stock
</template>
  
<script>
export default {
  props: {
    parentData: {
      type: Object,
      default: null
    },
    selectedDocument: {
      type: Object,
      required: true
    },
    selectedItems: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isReceivedMode () {
      if (this.selectedDocument.id === 'stock-transfer') {
        return ['approved', 'completed'].includes(this.status)
      }
      if (this.selectedDocument.id === 'quotation') {
        return false
      }
      return true
    },
    showProgressTotal () {
      if (this.selectedDocument.id === 'invoice') return false
      if (this.selectedDocument.id === 'stock-transfer') {
        return ['approved', 'completed'].includes(this.status)
      }
      return this.status === 'active'
    },
    totalReceived () {
      return this.selectedItems.reduce((acc, item) => {
        const receivedQty = item.receivedQty || 0
        return acc + receivedQty
      }, 0)
    },
    stockCount () {
      if (!this.isReceivedMode) return this.totalRequested
      if (this.selectedDocument.id !== 'stock-transfer' && this.parentData?.order_status === 'draft') return 0
      return this.totalReceived
    },
    totalRequested () {
      return this.selectedItems.reduce((acc, item) => {
        const requestedQty = item.requestedQty || 0
        return acc + requestedQty
      }, 0)
    },
    requestPercentage () {
      return this.totalRequested === 0 ? 0 : (this.stockCount / this.totalRequested) * 100
    },
    countColor () {
      if (!['quotation', 'stock-transfer'].includes(this.selectedDocument.id) && this.parentData?.order_status === 'draft') return 'neutral500--text'
      return 'neutral700--text'
    },
    status () {
      return this.parentData?.request_status || this.parentData?.order_status
    }
  },
}
</script>

<style scoped>
</style>